<div class="company-cbp-assigned-number-request-start-page">
  <div class="company-cbp-assigned-number-request-start-page__header">
    <p class="company-cbp-assigned-number-request-start-page__header-title">{{ "LABELS.ASSIGNED_CBP_ACTION_BOX.TITLE" | translate }}</p>
  </div>

  <div class="company-cbp-assigned-number-request-start-page__description-container">
    <p class="company-cbp-assigned-number-request-start-page__text bold-weight">
      {{ "LABELS.ASSIGNED_CBP_NUMBER_REQUEST_DESCRIPTION.LINE_1" | translate }}
    </p>
    <p class="company-cbp-assigned-number-request-start-page__text medium-weight">
      {{ "LABELS.ASSIGNED_CBP_NUMBER_REQUEST_DESCRIPTION.LINE_2" | translate }}
    </p>
    <p class="company-cbp-assigned-number-request-start-page__text">
      {{ "LABELS.ASSIGNED_CBP_NUMBER_REQUEST_DESCRIPTION.LINE_3" | translate }}
    </p>
  </div>

  <cbp-number-request-identifier-type-form [formGroup]="formGroup"></cbp-number-request-identifier-type-form>

  <cbp-number-request-business-type-form [formGroup]="formGroup"></cbp-number-request-business-type-form>

  <div class="company-cbp-assigned-number-request-start-page__required-documents">
    <p class="company-cbp-assigned-number-request-start-page__text bold-weight">
      {{ "LABELS.REQUIRED_APPLICATION_DOCUMENTS" | translate }}
    </p>
    <ul>
      <li
        *ngFor="let text of selectedRequiredDocumentsTextsArray"
        class="company-cbp-assigned-number-request-start-page__list-item"
        [innerHTML]="text | translate"
      ></li>

      <li class="company-cbp-assigned-number-request-start-page__list-item no-marker">
        <a [href]="poaFileUrl" target="_blank" download>
          <span class="company-cbp-assigned-number-request-start-page__download-icon-container">
            <icon-download fill="#2060C0"></icon-download>
          </span>
          {{ "BUTTON.DOWNLOAD_POA_FORM_SHORT" | translate }}
        </a>
      </li>
    </ul>
  </div>
</div>
